<div class="flex justify-content-center p-0">
	<div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
		<div class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<h3 >{{ 'button.conference' | translate }}</h3>
			</div>
		</div>
		<div class="pb-0">
			<label>{{ 'h5.labelCode' | translate }}</label>
			<input  type="number" min=1 minlength="1" maxlength="16" pattern="^[0-9]*$" tabindex="-1"
					[ngClass]="{focusField: inputFields[0].focus}" pInputText
					[(ngModel)]="inputFields[0].value" [id]="inputFields[0].id"
					onkeydown="if(event.key==='.' || event.key==='-' || event.key==='+' || event.key==='e'){event.preventDefault();}"
					(keydown.enter)="checkLabelConference()"
					(focus)="checkInputValid('label_conference')"/>

			<div class="card pl-3 pb-2 pt-0" *ngIf="showPartAndDescription && inputFields[0].valid === true">
				<div class="p-1 z-0">
					<h5>{{ 'h5.part' | translate }}: <span class="text-sm opacity-60 ">{{receivementFollowUpResponse[0].partCode}}</span></h5>
					<h5>{{ 'h5.description' | translate }}: <span class="text-sm opacity-60 ">{{receivementFollowUpResponse[0].description}}</span></h5>
				</div>
			</div>
		</div>

		<div class="pb-0">
			<label>{{ 'h5.quantity' | translate }}</label>
			<input type="number" min=1 minlength="1" pInputText
				   [id]="inputFields[1].id" [disabled]="inputQuantityDisable"
				   [ngClass]="{focusField: inputFields[1].focus}" inputmode="numeric"  tabindex="-1"
				   (keydown.enter)="checkQuantity()" [(ngModel)]="inputFields[1].value"
				   (focus)="checkInputValid('input_quantity')"
				   onkeydown="if(event.key==='.' || event.key==='-' || event.key==='+' || event.key==='e'){event.preventDefault();}"
				   (ngModelChange)="checkInputValid('input_quantity')"/>
			<div *ngIf="invalidAmount" id="invalid" class="p-error">{{ 'modal.invalidAmount' | translate }}.</div>
			<h5 *ngIf="inputFields[0].valid && receivementFollowUpResponse && receivementFollowUpResponse.length" class="info-qty text-right">{{ 'h5.quantityAbbreviated' | translate }}: {{ receivementFollowUpResponse[0].receivingQty }}</h5>
		</div>
		<div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
			<div class="flex justify-content-center p-0">
				<div class="p-col-12 p-md-6 p-lg-3 p-0">
					<button type="submit"  id="button_ok" class="btn btn-primary submit" pButton pRipple [disabled]="checkInputs()"
							(click)="operationConfirm()" label="{{ 'h5.messageOk' | translate }}">
					</button>					
				</div>
			</div>
		</div>
	</div>
</div>

<input-generic
	[inputFields] = "inputFields"
	(eventEmitter) = "executeAction($event)">
</input-generic>

<alert-custom *ngIf="showAlert"
		(onCloseModal)="hideErrorModal($event)"
		[msg]="errorMessage"
		[elId]="errorFocus"
		[title]="errorTitle">
</alert-custom>

<p-confirmDialog header="Confirmation"></p-confirmDialog>

<p-dialog  [(visible)]="displayModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ margin:'0 10px 0 10px'}">
	<ng-template pTemplate="header">{{'modal.attention' | translate}}</ng-template>
	<div class="dialog-body ">
	<h4>{{'modal.partParamProblem' | translate}}</h4> 

	<h3>{{partError}}</h3>
	
	</div>
	<ng-template pTemplate="footer">
		<button (click)="closeModal()"
			id="closeModal"
			type="button" pButton
			label="{{'modal.continue' | translate}}"
			class="cancel-button" >
		</button>	
	</ng-template>
</p-dialog>
